import styled from 'styled-components';
import banner from '../../assets/images/Rectangle.svg';

export const Warper = styled.div`
  width: 100vw;
  height: 100vh;
  display: grid;
  grid-template-columns: 11rem 1fr;
  grid-gap: 1rem;
  background-color: #cdcccc66;
`;

export const SmallSizeScreen = styled.div`
  background-image: url(${banner});
  background-repeat: no-repeat;
  background-position: right;
  background-size: cover;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #b69a43;
  .maintenanceImg {
    width: 170px;
  }
  h2 {
    margin: 0.25rem;
    text-align: center;
  }
`;
